<template>
  <div class="q-pa-md q-mx-auto" style="max-width: 1000px">
    <h6 class="text-center" v-if="userName">
      {{ userName }} - {{ userRoleToName(store.state.user) }} - Dashboard
    </h6>
    <q-table
      class="q-mb-lg"
      :rows="paymentSummary"
      :columns="columns"
      row-key="state"
      separator="horizontal"
      hide-bottom
      :rows-per-page-options="[0]"
    />
    <div>All Admins</div>
  </div>
</template>

<script setup lang="ts">
// import CSTable from "@/components/CharitySystem/CSTable.vue";
import { ref, computed, onMounted } from "vue";
import { useStore } from "@/store";
import { processResponse, userRoleToName } from "@/shared/helperFunctions";
import DonorPaymentUseCase from "@/usecases/DonorPaymentUseCase";
import { DonorPaymentSummary } from "@/models/APIModels/DonorPayment";
import { showErrorNotification } from "@/components/shared/dialog";
import { useQuasar } from "quasar";
import { ApiException } from "@/api/ResponseModel";

const paymentSummary = ref<DonorPaymentSummary>([]);

const store = useStore();
const $q = useQuasar();

const userName = computed(() => {
  const user = store.state.user;
  return user ? `${user.givenName} ${user.familyName}` : "";
});

onMounted(async () => {
  try {
    const donorPaymentUseCase = new DonorPaymentUseCase();
    const result = await donorPaymentUseCase.donorPaymentSummary();
    processResponse(result, (data) => {
      paymentSummary.value = data;
    });
  } catch (ex) {
    $q.notify(showErrorNotification((ex as ApiException).description));
  }
});

const columns = [
  {
    name: "state",
    field: "australianStateCd",
    label: "State",

    required: true,
    sortable: false,
  },
  {
    name: "numberOfSchools",
    field: "numberOfSchools",
    label: "Number Of Schools",

    required: true,
    sortable: false,
  },
  {
    name: "numberOfDonors",
    field: "numberOfDonors",
    label: "Number Of Donors",

    required: true,
    sortable: false,
  },
  {
    name: "totalDonationsMade",
    field: "numberofDonations",
    label: "Total Donations Made",

    required: true,
    sortable: false,
  },
  {
    name: "totalDonationsReceived",
    field: "totalDonationAmt",
    label: "Total Donations Recieved",

    required: true,
    sortable: false,
  },
];
</script>
